module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/cenicilla_tomate/preventiva/vacciplant.png
// module id = 2391
// module chunks = 3